const storageAndSecurity = [
  {
    heading: 'Security',
    paragraphs: [
      'The security of your information is of paramount importance to us. In order to secure your personal information, access to your data is password-protected, and all data is protected by SSL encryption when it is exchanged between your web browser or other device and our website. To protect any data you store on our servers we also regularly audit our system for possible vulnerabilities and attacks.',
    ],
  },
  {
    heading: 'Information Sharing',
    paragraphs: [
      'Since we use Google Analytics and Facebook Pixel Tracking to gather usage data of our website and apps, the companies may use their own cookies, gather usage profile information linked to the device you use to access our website and apps. This information cannot be connected to the personally identifiable information you provide us with.',
      'When you provide us with credit card details, those details are not sent to our server but instead stored by our card payment merchant, Stripe. Please review the Stripe Privacy Policy for more details on how they might use this information. We do not share your information with third parties without your explicit permission.',
    ],
  },
]

export default storageAndSecurity
